<div class="container pt-5">


    <div class="row">

        <div class="col-2 col-sm-8"></div>
        <!-- <div class="col-12 mt-2 mb-2">
            <h2 class="accent bold" style="font-size: 0.9970rem">
                <strong>Sign-Up</strong>
            </h2>
        </div> -->
        <!-- Account Type -->
        <!-- <div class="col-12 mb-2" *ngIf="!cancel">
            <h6 style="font-size: 0.9970rem"><strong>User Type</strong></h6>
            <div class="radiobtn">
                <mat-radio-group name="submissiontype" [(ngModel)]="labelPosition" (change)="radioChange($event)" class="row">
                   
                   
              <mat-radio-button value="0" color="primary" checked="checked" >
                        Individual &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                    </mat-radio-button>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                     <mat-radio-button value="1" color="primary">Business
                    </mat-radio-button>
                    <mat-radio-button class="example-margin" value="Individual">Individual</mat-radio-button>
                </mat-radio-group>
            </div>
        </div> -->

        <!-- 
        <div class="col-12 mb-2" *ngIf="cancel">
            <h5 style="font-size: 0.9970rem"><strong>User Type</strong></h5>
            <div class="radiobtn" class="row">
                <mat-radio-group name="submissiontype" [(value)]="selected" (change)="radioChange($event)" class="row">
                   
                    <mat-radio-button value="0" style="border-right: 1px solid #a7bbc8;">
                        Individual&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                    </mat-radio-button>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;

          
                </mat-radio-group>&nbsp;
            </div>

        </div> -->

        <!-- <button mat-flat-button color="primary" class="loginbtn mr-2" [routerLink]="['/']"
            *ngIf="!Individual && !Business">Cancel</button> -->


    </div>


    <form name="enrollForm" [formGroup]="enrollForm" (ngSubmit)="AddEnroll(enrollForm.value)" autocomplete="off">
        <div class="row">
            <div class="col-12 mb-3">
                <h2 class="accent" style="font-size: 0.9970rem">Individual Enrol Application</h2>
            </div>
            <div class="col-12 mb-3">
                <h2 class="accent" style="font-size: 0.9970rem"><label style="color:red">Note:</label>Existing client
                    settlement instructions cannot be changed via this option.</h2>
            </div>

            <div class="col-12 col-sm-4">
                <mat-form-field appearance="outline" class="w-100">
                    <mat-label>NIB Number <label style="color:red">*</label></mat-label>
                    <input matInput type="number" class="example-right-align" name="NIBNumber"
                        (keypress)="keyPressNumbers($event)" formControlName="NIBNumber" autocomplete="off"
                        onKeyPress="if(this.value.length==8) return false;">
                    <mat-error *ngIf="enrollForm.controls.NIBNumber.invalid">
                        NIB Number should contain 8
                        characters
                    </mat-error>
                </mat-form-field>
            </div>
            <div class="col-12 col-sm-4">


                <mat-form-field appearance="outline" class="w-100">
                    <mat-label>Password <label style="color:red">*</label></mat-label>
                    <input matInput name="NewPassword" type="password" formControlName="NewPassword" autocomplete="off"
                        onKeyPress="if(this.value.length==20) return false;">
                    <mat-error
                        *ngIf="enrollForm.controls.NewPassword.value.length>0 && enrollForm.controls.NewPassword.invalid">
                        Password should contain at least one uppercase letter,one number,one special and minimum 8
                        maximum 20
                        characters
                    </mat-error>
                    <mat-icon matSuffix matTooltip="Your new password must contain at least one uppercase letter, 
                                    one lowercase letter, one number, and one special character with 
                                    minimum 8 and maximum 20 characters.">
                        information
                    </mat-icon>
                </mat-form-field>
            </div>
            <div class="col-12 col-sm-4">
                <mat-form-field appearance="outline" class="w-100">
                    <mat-label>Confirm Password <label style="color:red">*</label></mat-label>
                    <input matInput name="ConfirmPassword" type="password" formControlName="ConfirmPassword"
                        autocomplete="off" onKeyPress="if(this.value.length==20) return false;">
                    <mat-error *ngIf="enrollForm.controls.ConfirmPassword.invalid">
                        Please Enter Confirm Password
                    </mat-error>
                </mat-form-field>
            </div>
            <div class="col-12 col-sm-4">
                <mat-form-field appearance="outline" class="w-100">
                    <mat-label>First Name <label style="color:red">*</label></mat-label>
                    <input matInput name="FirstName" formControlName="FirstName" autocomplete="off">
                </mat-form-field>
            </div>
            <div class="col-12 col-sm-4">
                <mat-form-field appearance="outline" class="w-100">
                    <mat-label>Middle Name <label style="color:red">*</label></mat-label>
                    <input matInput name="MiddleName" formControlName="MiddleName" autocomplete="off">
                </mat-form-field>
            </div>
            <div class="col-12 col-sm-4">
                <mat-form-field appearance="outline" class="w-100">
                    <mat-label>Last Name <label style="color:red">*</label></mat-label>
                    <input matInput name="LastName" formControlName="LastName" autocomplete="off">
                </mat-form-field>
            </div>
            <div class="col-12 col-sm-4">
                <mat-form-field appearance="outline" class="w-100">
                    <mat-label>Email <label style="color:red">*</label></mat-label>
                    <input matInput name="Email" formControlName="Email" autocomplete="off">
                </mat-form-field>
            </div>

            <div class="col-12 col-sm-4">
                <mat-form-field appearance="outline" class="w-100">
                    <mat-label>Confirm Email <label style="color:red">*</label></mat-label>
                    <input matInput name="ConfirmEmail" formControlName="ConfirmEmail" autocomplete="off">
                </mat-form-field>
            </div>



            <div class="col-12 col-sm-4">
                <mat-form-field appearance="outline" class="w-100">
                    <!-- <mat-label>Passport Expiration Date </mat-label> -->
                    <mat-label>Expiration Date <label style="color:red">*</label></mat-label>

                    <input matInput [matDatepicker]="picker1" placeholder="MM/DD/YYYY" formControlName="expirydate"
                        autocomplete="off" readonly>
                    <mat-datepicker-toggle matSuffix [for]="picker1"></mat-datepicker-toggle>
                    <mat-datepicker #picker1></mat-datepicker>
                </mat-form-field><br>
            </div>

            <div class="col-12 col-sm-4">
                <mat-form-field appearance="outline" class="w-100">
                    <mat-label>Birthday <label style="color:red">*</label></mat-label>
                    <input matInput [matDatepicker]="picker" formControlName="Birthday" autocomplete="off" readonly>
                    <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
                    <mat-datepicker #picker></mat-datepicker>
                </mat-form-field><br>
            </div>

            <div class="col-12 col-sm-4">
            </div>

            <div class="col-8">
                <h4 style="font-size: 0.9970rem"> Banking Info<label style="color:red"> </label> </h4>

                <div class="row">
                    <div class="col-12 col-sm-4">
                        <mat-form-field appearance="outline" class="w-100">
                            <mat-label>Bank Name(Optional) </mat-label>
                            <input matInput formControlName="bankname" name="relatedissue">
                        </mat-form-field>
                    </div>

                    <div class="col-12 col-sm-4">
                        <mat-form-field appearance="outline" class="w-100">
                            <mat-label>Branch(Optional) </mat-label>
                            <input matInput formControlName="branch" name="relatedissue">
                        </mat-form-field>
                    </div>

                    <div class="col-12 col-sm-4">
                        <mat-form-field appearance="outline" class="w-100">
                            <mat-label>Account Number(Optional) </mat-label>
                            <input matInput formControlName="accountnumber" name="relatedissue">
                        </mat-form-field>
                    </div>
                </div>
            </div>




            <div class="col-12 col-sm-4"></div>
            <div class="col-12 col-sm-4">
                <mat-form-field appearance="outline" class="w-100">
                    <mat-label>Address <label style="color:red">*</label></mat-label>
                    <textarea matInput formControlName="IndividualAddress" name="IndividualAddress"
                        type="text"></textarea>
                </mat-form-field>

            </div>

            <div class="col-12 col-sm-4">
                <mat-form-field appearance="outline" class="w-100">
                    <mat-label>Primary Phone Number <label style="color:red">*</label></mat-label>
                    <input matInput name="IndividualPhone" formControlName="IndividualPhone" autocomplete="off">
                </mat-form-field>
            </div>

            <div class="col-12 col-sm-4">
                <mat-form-field appearance="outline" class="w-100">
                    <mat-label>Phone Number1(Optional) </mat-label>
                    <input matInput name="PhoneNumber" formControlName="IndividualPhone1" autocomplete="off">
                </mat-form-field>
            </div>


            <div class="col-12 col-sm-4">
                <mat-form-field appearance="outline" class="w-100">
                    <mat-label>Phone Number2(Optional) </mat-label>
                    <input matInput name="PhoneNumber" formControlName="IndividualPhone2" autocomplete="off">
                </mat-form-field>
            </div>

            <div class="col-12 col-sm-4">
                <mat-form-field appearance="outline" class="w-100">
                    <mat-label>Occupation/Source of Income <label style="color:red">*</label></mat-label>
                    <input matInput name="Occupation" formControlName="Occupation" autocomplete="off">
                </mat-form-field>
            </div>
            <div class="col-12 col-sm-4">
                <h6 style="font-size: 0.9970rem"><strong>Identification Type <label style="color:red">*</label></strong>
                </h6>
                <div class="radiobtn">
                    <mat-radio-group formControlName="ideType" (change)="onChangeAppType1($event)" name="ideType"
                        aria-label="Select an option">
                        <mat-radio-button value="0"> Passport</mat-radio-button>
                        <mat-radio-button value="1">Driver’s
                            License AND National Insurance Card</mat-radio-button>
                        <!-- <mat-error *ngIf="enrollForm.controls.ideType.invalid">
                   
                    </mat-error> -->
                    </mat-radio-group>

                </div>


            </div>



            <div class="col-12" *ngIf="uploadpassportfiles">
                <h4 style="font-size: 0.9970rem">Upload Passport
                    <span class="text-muted"> <label style="color:red">
                            <h5 style="font-size: 0.9970rem">(JPG and PDF files are allowed)</h5>
                        </label></span>
                </h4>
                <div class="input-group w-100 mb-2">
                    <div class="custom-file">
                        <input type="file" id="inputGroupFile03" aria-describedby="inputGroupFileAddon03"
                            (change)="onFileChange($event)" accept="image/jpg,image/jpeg,application/pdf">

                        <label class="custom-file-label" for="inputGroupFile03">{{this.fileInput}}</label>

                    </div>
                </div>
            </div>


            <div class="col-12" *ngIf="UploadNationalInsurancefiles">
                <h4 style="font-size: 0.9970rem"> Upload Driver’s License
                    <span class="text-muted"> <label style="color:red">
                            <h5 style="font-size: 0.9970rem">(JPG and PDF files are allowed)</h5>
                        </label></span>
                </h4>
                <div class="input-group w-100 mb-2">
                    <div class="custom-file">
                        <input type="file" id="inputGroupFile01" aria-describedby="inputGroupFileAddon01"
                            (change)="onFileChangeDriversLicense($event)" accept="image/jpg,image/jpeg,application/pdf">
                        <label class="custom-file-label" for="inputGroupFile01">{{this.DriversLicensefileInput}}</label>
                    </div>
                </div>&nbsp;


                <h4 style="font-size: 0.9970rem"> Upload National Insurance Card
                    <span class="text-muted"> <label style="color:red">
                            <h5 style="font-size: 0.9970rem">(JPG and PDF files are allowed)</h5>
                        </label></span>
                </h4>
                <div class="input-group w-100 mb-2">
                    <div class="custom-file">
                        <input type="file" id="inputGroupFile02" aria-describedby="inputGroupFileAddon02"
                            (change)="onFileChangeNationalInsuranceCard($event)"
                            accept="image/jpg,image/jpeg,application/pdf">
                        <label class="custom-file-label"
                            for="inputGroupFile02">{{this.NationalInsuranceCardfileInput}}</label>


                    </div>
                </div>

            </div>




            <div class="col-12 col-sm-4" *ngIf=passportNumberEnable>
                <mat-form-field appearance="outline" class="w-100">
                    <!-- <mat-label>Passport Number</mat-label> -->
                    <mat-label>Passport Number <label style="color:red">*</label></mat-label>
                    <input matInput name="PassportNumber" [formControl]="PassportNumber" autocomplete="off">
                </mat-form-field>
            </div>

            <div class="col-12 col-sm-4" *ngIf=drivingLincenceNumberEnable>
                <mat-form-field appearance="outline" class="W-100">
                    <!-- <mat-label>Passport Number</mat-label> -->
                    <mat-label><label style="color:red">*</label> Driver’s License & InsuranceCard Number </mat-label>
                    <input matInput name="PassportNumber" [formControl]="InsuranceCardNumber" autocomplete="off">
                </mat-form-field>
            </div>
            <div class="col-12">
                <button mat-flat-button type="submit" color="primary" class="loginbtn mr-2">Submit</button>

                <button mat-flat-button color="primary" class="loginbtn mr-2" [routerLink]="['/']">Cancel</button>

                <!-- </div> -->
            </div>
        </div>


    </form>

    <!-- Business Enroll  -->
    <form name="enrollFormBusiness" [formGroup]="enrollFormBusiness"
        (ngSubmit)="AddEnrollBusiness(enrollFormBusiness.value)">
        <div *ngIf="Business" class="row" autocomplete="off">

            <div class="col-12 mb-3">
                <h2 class="accent" style="font-size: 0.9970rem">Enrol Application</h2>
            </div>

            <div class="col-12 col-sm-4">
                <mat-form-field appearance="outline" class="w-100">
                    <mat-label>ID Number <label style="color:red">*</label></mat-label>
                    <input matInput type="number" class="example-right-align" name="NIBNumber"
                        formControlName="NIBNumber" autocomplete="off"
                        onKeyPress="if(this.value.length==8) return false;">
                    <mat-error *ngIf="enrollForm.controls.NIBNumber.invalid">
                        ID Number should contain 8
                        characters
                    </mat-error>
                </mat-form-field>
            </div>

            <div class="col-12 col-sm-4">
                <mat-form-field appearance="outline" class="w-100">
                    <mat-label>Business Name <label style="color:red">*</label></mat-label>
                    <input matInput name="Bname" formControlName="Bname" autocomplete="off">
                </mat-form-field>
            </div>

            <div class="col-12 col-sm-4">
                <mat-form-field appearance="outline" class="w-100">
                    <mat-label>Trading As (optional) </mat-label>
                    <input matInput name="trading" formControlName="trading" autocomplete="off">
                </mat-form-field>
            </div>

            <div class="col-12 col-md-4">
                <mat-form-field appearance="outline" class="w-100 ">
                    <mat-label>Business Type <label style="color:red">* </label></mat-label>
                    <input matInput name="Btype" formControlName="Btype" autocomplete="off">
                </mat-form-field>
            </div>

            <div class="col-12 col-sm-4">
                <mat-form-field appearance="outline" class="w-100">
                    <mat-label> Business Address <label style="color:red">*</label></mat-label>
                    <textarea matInput formControlName="Baddress" name="Baddress" type="text"></textarea>
                </mat-form-field>
            </div>

            <div class="col-12 col-sm-4">
                <mat-form-field appearance="outline" class="w-100">
                    <mat-label> Business Email Address <label style="color:red">*</label></mat-label>
                    <input matInput formControlName="Bemailaddress" name="Bemailaddress" autocomplete="off">
                </mat-form-field>

            </div>

            <div class="col-12 col-sm-4">
                <mat-form-field appearance="outline" class="w-100">
                    <mat-label>Date of Inception <label style="color:red">*</label></mat-label>
                    <input matInput [matDatepicker]="picker1" formControlName="DateofInception" autocomplete="off"
                        readonly>
                    <mat-datepicker-toggle matSuffix [for]="picker1"></mat-datepicker-toggle>
                    <mat-datepicker #picker1></mat-datepicker>
                </mat-form-field>
            </div>

            <div class="col-12 col-sm-4">

            </div>

            <!-- Primary Contacts -->

            <div class="col-8">
                <h4 style="font-size: 0.9970rem"> Primary Contacts<label style="color:red"> </label> </h4>

                <div class="row">
                    <div class="col-12 col-sm-4">
                        <mat-form-field appearance="outline" class="w-100">
                            <mat-label> Name <label style="color:red">*</label></mat-label>
                            <input matInput formControlName="BPname" name="BPname">
                        </mat-form-field>
                    </div>

                    <div class="col-12 col-sm-4">
                        <mat-form-field appearance="outline" class="w-100">
                            <mat-label> Email Address <label style="color:red">*</label></mat-label>
                            <input matInput formControlName="BPemailaddress" name="BPemailaddress">
                        </mat-form-field>
                    </div>

                    <div class="col-12 col-sm-4">
                        <mat-form-field appearance="outline" class="w-100">
                            <mat-label> Phone <label style="color:red">*</label></mat-label>
                            <input matInput formControlName="BPphone" name="BPphone">
                        </mat-form-field>
                    </div>
                </div>
            </div>

            <!-- Secondary Contacts -->
            <div class="col-8">
                <h4 style="font-size: 0.9970rem"> Secondary Contacts </h4>

                <div class="row">
                    <div class="col-12 col-sm-4">
                        <mat-form-field appearance="outline" class="w-100">
                            <mat-label> Name </mat-label>
                            <input matInput formControlName="SBname" name="SBname">
                        </mat-form-field>
                    </div>

                    <div class="col-12 col-sm-4">
                        <mat-form-field appearance="outline" class="w-100">
                            <mat-label> Email Address</mat-label>
                            <input matInput formControlName="SBemailaddress" name="SBemailaddress">
                        </mat-form-field>
                    </div>

                    <div class="col-12 col-sm-4">
                        <mat-form-field appearance="outline" class="w-100">
                            <mat-label> Phone </mat-label>
                            <input matInput formControlName="SBphone" name="SBphone">
                        </mat-form-field>
                    </div>
                </div>
            </div>

            <!-- Banking Info -->
            <div class="col-8">
                <h4 style="font-size: 0.9970rem"> Banking Info </h4>

                <div class="row">
                    <div class="col-12 col-sm-4">
                        <mat-form-field appearance="outline" class="w-100">
                            <mat-label>Bank Name </mat-label>
                            <input matInput formControlName="Bbankname" name="Bbankname">
                        </mat-form-field>

                    </div>

                    <div class="col-12 col-sm-4">
                        <mat-form-field appearance="outline" class="w-100">
                            <mat-label>Branch </mat-label>
                            <input matInput formControlName="Bbranch" name="Bbranch">
                        </mat-form-field>

                    </div>

                    <div class="col-12 col-sm-4">
                        <mat-form-field appearance="outline" class="w-100">
                            <mat-label>Account Number </mat-label>
                            <input matInput formControlName="Baccountnumber" name="Baccountnumber">
                        </mat-form-field>

                    </div>

                </div>
            </div>





            <!-- Document's Upload -->

            <div class="col-8">
                <div class="row">
                    <h4 style="font-size: 0.9970rem"> Beneficial Owner details (articles of incorporation or equivalent)
                        <span class="text-muted"> <label style="color:red">
                                <h5 style="font-size: 0.9970rem">( JPG and PDF files are allowed)</h5>
                            </label></span>
                    </h4>
                    <div class="input-group w-100 mb-2">
                        <div class="custom-file">
                            <input type="file" id="inputGroupFile01" aria-describedby="inputGroupFileAddon01"
                                (change)="onFileChangeBeneficial($event)" accept="image/jpg,image/jpeg,application/pdf"
                                formControlName="beneficialdocs">
                            <label class="custom-file-label" for="inputGroupFile01">{{this.BeneficialfileInput}}</label>
                        </div>
                    </div>&nbsp;


                    <h4 style="font-size: 0.9970rem"> Authorized Signatories and specimen signatures
                        <span class="text-muted"> <label style="color:red">
                                <h5 style="font-size: 0.9970rem">( JPG and PDF files are allowed)</h5>
                            </label></span>
                    </h4>
                    <div class="input-group w-100 mb-2">
                        <div class="custom-file">
                            <input type="file" id="inputGroupFile02" aria-describedby="inputGroupFileAddon02"
                                (change)="onFileChangeAuthorized($event)" accept="image/jpg,image/jpeg,application/pdf"
                                formControlName="authorizeddocs">
                            <label class="custom-file-label" for="inputGroupFile02">{{this.AuthorizedfileInput}}</label>


                        </div>
                    </div>

                    <h4 style="font-size: 0.9970rem"> Business license/VAT registration
                        <span class="text-muted"> <label style="color:red">
                                <h5 style="font-size: 0.9970rem">( JPG and PDF files are allowed)</h5>
                            </label></span>
                    </h4>
                    <div class="input-group w-100 mb-2">
                        <div class="custom-file">
                            <input type="file" id="inputGroupFile03" aria-describedby="inputGroupFileAddon03"
                                (change)="onFileChangeBusiness($event)" accept="image/jpg,image/jpeg,application/pdf"
                                formControlName="Businessdocs">
                            <label class="custom-file-label" for="inputGroupFile03">{{this.BusinessfileInput}}</label>


                        </div>
                    </div>

                </div>





            </div>






        </div>
        <div class="row">
            <div class="col-12">
                <button mat-flat-button type="submit" color="primary" class="loginbtn mr-2"
                    *ngIf="Business">Submit</button>

                <button mat-flat-button color="primary" class="loginbtn mr-2" [routerLink]="['/']" *ngIf="Business">
                    Cancel</button>

            </div>
        </div>
    </form>

</div>

<div class="mat-spinner-fullscreen" [hidden]="loadingData1">
    <mat-spinner style="margin:0 auto;" class="pink-spinner .mat-spinner-bar-buffer" mode="indeterminate">
    </mat-spinner>
</div>